import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActionSheetController, ModalController, NavController, NavParams } from 'ionic-angular';
import { TournamentService } from '../../../services/tournament.service';
import { ResultEditPreRoundPage } from '../../edits/pre-round/edit-pre-round';

/**
 * Spielpaarung
 * Interface for plan
 */

@Component({
  selector: 'result-pre-round',
  templateUrl: 'result-pre-round.html',
})
export class ResultPreRoundPage {
  gamePlanList: IGamePlan[] = [];
  @Input() activePlan: any = 0;
  @Input() header: boolean = true;
  
  constructor(
    private navParams: NavParams,
    private modalCtrl: ModalController,
    private gs: TournamentService,
    private actionCtrl: ActionSheetController,
    private translate: TranslateService
  ) { 
    this.activePlan = this.navParams.get('activePlan') || this.activePlan;
  }

  sort(){
    if(!this.gs.planList[this.activePlan]) return [];

    return this.gs.planList[this.activePlan].teams.sort((a, b) => b.points - a.points);
  }

  getGroupName(i: number){
    let ASCII = 65;
    return String.fromCharCode(ASCII + i);
  }

  onOpenEdit(roundIndex: number, groupIndex: number, pareIndex: number){
    let modal = this.modalCtrl.create(ResultEditPreRoundPage, { activePlan: this.activePlan, pareIndex: pareIndex, groupIndex: groupIndex, roundIndex: roundIndex });
    modal.present();
  }

  onRemoveTeam(roundIndex: number, groupIndex: number, pareIndex: number){
    let sheet = this.actionCtrl.create({
      title: this.translate.instant('MYSPORT_PHOTOS_SHEET_TITLE'),
      buttons: [
        {
          text: this.translate.instant('MYSPORT_PHOTOS_SHEET_DELETE'),
          role: 'destructive',
          handler: () => {
            this.gs.planList[this.activePlan].gameTable[roundIndex][groupIndex].splice(pareIndex, 1);
            this.gs.save();
          }
        },
        {
          text: this.translate.instant('MYSPORT_PHOTOS_SHEET_CANCEL'),
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    sheet.present();
  }

}

export interface IGamePlan {
  id: number;
  gameDay: number;
  name: string;
  team1: {
    id: number;
    name: string;
  };
  team2: {
    id: number;
    name: string;
  }
}






// WEBPACK FOOTER //
// /src/pages/apps/gamer/pages/results/result-pre-round/result-pre-round.ts